// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../public/LoginPageBackground.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body, html {
    margin: 0;
    padding: 0;
    height: 100%;
    font-family: 'Arial', sans-serif;
    background-color: #f0f4f7; /* Assuming a light blue background for any overflow */
}

.login-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: cover;
    background-position: center;
    color: #1456e3cb;
}

h2 {
    font-size: 3rem; /* Keeps the text size large */
    color: rgb(88, 255, 249); /* Or any other color that matches your image */
    text-shadow:
        -1px -1px 0 #000,
         1px -1px 0 #000,
        -1px  1px 0 #000,
         1px  1px 0 #000; /* This creates the outline effect */
    margin-bottom: 20px;
}

.google-signin-btn {
    background-color: #00b4d8; /* Changed to a blue to match the h2 and the image's scheme */
    color: white;
    border: none;
    padding: 10px 20px;
    cursor: pointer;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
    transition: all 0.3s ease;
    font-size: 1.2rem; /* Slightly larger font for the button */
    font-weight: bold; /* Makes the text bold */
}

.google-signin-btn:hover {
    background-color: #0077b6; /* A darker shade of blue for the hover effect */
    transform: scale(1.05); /* Slightly enlarges the button when hovered for a dynamic effect */
}
`, "",{"version":3,"sources":["webpack://./src/components/Login.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;IACV,YAAY;IACZ,gCAAgC;IAChC,yBAAyB,EAAE,sDAAsD;AACrF;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,yDAA6D;IAC7D,sBAAsB;IACtB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,eAAe,EAAE,8BAA8B;IAC/C,wBAAwB,EAAE,+CAA+C;IACzE;;;;wBAIoB,EAAE,oCAAoC;IAC1D,mBAAmB;AACvB;;AAEA;IACI,yBAAyB,EAAE,6DAA6D;IACxF,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,qCAAqC;IACrC,yBAAyB;IACzB,iBAAiB,EAAE,wCAAwC;IAC3D,iBAAiB,EAAE,wBAAwB;AAC/C;;AAEA;IACI,yBAAyB,EAAE,gDAAgD;IAC3E,sBAAsB,EAAE,mEAAmE;AAC/F","sourcesContent":["body, html {\n    margin: 0;\n    padding: 0;\n    height: 100%;\n    font-family: 'Arial', sans-serif;\n    background-color: #f0f4f7; /* Assuming a light blue background for any overflow */\n}\n\n.login-container {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    height: 100vh;\n    background-image: url('../../public/LoginPageBackground.png');\n    background-size: cover;\n    background-position: center;\n    color: #1456e3cb;\n}\n\nh2 {\n    font-size: 3rem; /* Keeps the text size large */\n    color: rgb(88, 255, 249); /* Or any other color that matches your image */\n    text-shadow:\n        -1px -1px 0 #000,\n         1px -1px 0 #000,\n        -1px  1px 0 #000,\n         1px  1px 0 #000; /* This creates the outline effect */\n    margin-bottom: 20px;\n}\n\n.google-signin-btn {\n    background-color: #00b4d8; /* Changed to a blue to match the h2 and the image's scheme */\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    cursor: pointer;\n    border-radius: 5px;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.2);\n    transition: all 0.3s ease;\n    font-size: 1.2rem; /* Slightly larger font for the button */\n    font-weight: bold; /* Makes the text bold */\n}\n\n.google-signin-btn:hover {\n    background-color: #0077b6; /* A darker shade of blue for the hover effect */\n    transform: scale(1.05); /* Slightly enlarges the button when hovered for a dynamic effect */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
